<template>
  <div>
    <input 
      type="email" 
      class="text" 
      @input="setFieldData" 
      :class="options.css_classes" 
      :id="'field-' + options.id + '-primary'" 
      v-model="field_data.primary"
      style="margin-bottom: .5rem" /> 
    <input 
      type="email" 
      class="text" 
      @input="setFieldData" 
      :class="options.css_classes" 
      :id="'field-' + options.id + '-confirmed'" 
      v-model="field_data.confirmed" 
      placeholder="Re-enter email address" />
  </div>
</template>

<script>
export default { 
  name: 'EmailConfirmationField',
  props: {
    options: {
      type: Object,
      required: true
    },
    value: {
      type: String
    }
  },
  data () {
    return {
      field_data: {
        primary: '',
        confirmed: ''
      }
    }
  },
  methods: {
    setFieldData () {
      this.$commit.setFieldValue({
        key: 'field-' + this.options.id, 
        value: this.field_data 
      })
    },
    validate () {
      let primary = this.value.primary
      let confirmed = this.value.confirmed

      console.log('compare', primary, confirmed)
      if (
        this.$util.setValue(primary).isEmail() && 
        primary == confirmed
      ) {
        return true
      }
      return false
    }
  }
}
</script>
